
import { Question } from "../../types/assessment";
import { createGenericOptions } from "../utils";

export const innovationQuestions: Question[] = [
  {
    id: "i1",
    text: "Does your organization collaborate with AI startups or ecosystems?",
    dimension: "innovation",
    tooltip: "Assess the number and quality of partnerships your organization maintains with AI startups, research institutions, and innovation ecosystems. Consider both formal partnerships and informal collaboration networks.",
    options: createGenericOptions([
      "No external AI collaboration or partnerships",
      "1-2 startup partnerships with limited engagement",
      "3-5 active partnerships with defined objectives",
      "6-10 strategic ecosystem partnerships",
      "11-20 deep collaboration partnerships",
      "20+ innovation partnerships across ecosystem"
    ])
  },
  {
    id: "i2",
    text: "How do you foster AI innovation internally?",
    dimension: "innovation",
    tooltip: "Evaluate the structured programs, time allocation, and cultural elements in place to encourage AI innovation among employees. Consider hackathons, innovation days, and dedicated time for experimentation.",
    options: createGenericOptions([
      "No formal AI innovation program or initiatives",
      "Basic suggestion system with monthly review",
      "Regular innovation sessions (4-8 hours monthly)",
      "Weekly innovation sprints with dedicated time",
      "Daily innovation time (10% of work hours)",
      "Full innovation culture (20%+ time allocated)"
    ])
  },
  {
    id: "i3",
    text: "What is your AI research and development investment?",
    dimension: "innovation",
    tooltip: "Consider your organization's financial commitment to AI research and development as a percentage of revenue or total IT budget. Include both direct R&D spending and indirect investments like training and infrastructure.",
    options: createGenericOptions([
      "No dedicated R&D budget for AI initiatives",
      "Minimal investment (<1% of annual revenue)",
      "Growing R&D budget (2-3% of revenue)",
      "Significant investment (4-6% of revenue)",
      "Major R&D focus (7-10% of revenue)",
      "Industry-leading investment (>10% of revenue)"
    ])
  },
  {
    id: "i4",
    text: "How do you protect AI intellectual property?",
    dimension: "innovation",
    tooltip: "Assess your organization's approach to protecting AI-related intellectual property through patents, trade secrets, and other legal mechanisms. Consider both defensive and strategic IP approaches.",
    options: createGenericOptions([
      "No IP protection strategy for AI assets",
      "Basic NDAs and confidentiality agreements",
      "Standard patents (1-3 AI-related)",
      "Active IP portfolio (4-10 patents)",
      "Strategic IP program (11-20 patents)",
      "Comprehensive IP strategy (20+ patents)"
    ])
  },
  {
    id: "i5",
    text: "What is your approach to AI experimentation?",
    dimension: "innovation",
    tooltip: "Evaluate how systematically your organization tests new AI approaches, models, and applications. Consider the frequency, scale, and methodology of your experimentation process.",
    options: createGenericOptions([
      "No formal AI experimentation process",
      "Basic testing (1-2 experiments monthly)",
      "Regular experimentation (3-5 weekly)",
      "Active testing (5-10 parallel experiments)",
      "Systematic approach (20+ concurrent tests)",
      "Advanced program (50+ automated experiments)"
    ])
  },
  {
    id: "i6",
    text: "How do you share AI knowledge externally?",
    dimension: "innovation",
    tooltip: "Assess how actively your organization contributes to the broader AI community through publications, open-source contributions, conference presentations, and other knowledge-sharing activities.",
    options: createGenericOptions([
      "No external AI knowledge sharing",
      "Annual conference presentations",
      "Quarterly whitepapers and publications",
      "Monthly technical blog posts and papers",
      "Weekly knowledge sharing activities",
      "Daily contributions to AI community"
    ])
  },
  {
    id: "i7",
    text: "What AI research partnerships do you maintain?",
    dimension: "innovation",
    tooltip: "Evaluate the depth and breadth of your organization's formal research collaborations with academic institutions, research labs, and other organizations focused on advancing AI technology.",
    options: createGenericOptions([
      "No formal research partnerships",
      "Single academic collaboration",
      "2-3 research partnerships",
      "4-6 active research programs",
      "7-10 diverse research initiatives",
      "10+ global research collaborations"
    ])
  },
  {
    id: "i8",
    text: "How do you evaluate emerging AI technologies?",
    dimension: "innovation",
    tooltip: "Assess your organization's process for identifying, evaluating, and potentially adopting new AI technologies. Consider the formality, frequency, and effectiveness of your technology scanning approach.",
    options: createGenericOptions([
      "No formal evaluation of new AI technologies",
      "Annual technology review process",
      "Quarterly assessment of new capabilities",
      "Monthly evaluation of emerging tech",
      "Weekly technology radar updates",
      "Daily scanning and assessment process"
    ])
  },
  {
    id: "i9",
    text: "What is your AI patent strategy?",
    dimension: "innovation",
    tooltip: "Consider your organization's approach to patenting AI innovations. Evaluate not just the number of patents but also their strategic alignment with your business goals and competitive positioning.",
    options: createGenericOptions([
      "No AI patent strategy or filings",
      "1-2 patents in application process",
      "3-5 active patents with clear focus",
      "6-10 strategic patent portfolio",
      "11-20 patents across AI domains",
      "20+ diverse AI patent portfolio"
    ])
  },
  {
    id: "i10",
    text: "What is your organization's overall impact on the AI ecosystem?",
    dimension: "innovation",
    tooltip: "Evaluate how significantly your organization influences the broader AI industry through contributions to standards, open-source tools, public datasets, or other ecosystem-wide initiatives.",
    options: createGenericOptions([
      "No measurable ecosystem impact",
      "Local presence influencing 2-3 organizations",
      "Regional influence affecting 4-6 organizations",
      "National impact reaching 7-10 organizations",
      "Industry leadership impacting 11-20 entities",
      "Global innovation influencing 20+ organizations"
    ])
  }
];
